import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Table, ListHeader, Tabs, Tab, PaymentsTableHeader, PendingReportPayments, ReportedPayments, useUser, useWindowSize } from 'components';
import { ROLES } from 'enums';
import { showApiError } from 'utils';
import { getAllPayments } from 'services';
import { tableWrap } from 'styles';
import { paymentsListColumns } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AllPaymentsTab = function AllPaymentsTab() {
  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var tableRef = useRef();

  var fetchAllPayments = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getAllPayments, _yield$getAllPayments2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllPayments(tableOptions);

            case 2:
              _yield$getAllPayments = _context.sent;
              _yield$getAllPayments2 = _slicedToArray(_yield$getAllPayments, 2);
              res = _yield$getAllPayments2[0];
              err = _yield$getAllPayments2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              return _context.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAllPayments(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchAllPayments,
    columns: paymentsListColumns(roleAdditionalData, windowWidth),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: PaymentsTableHeader,
    margin: "0 2em",
    pageSize: 20
  }));
};

var PaymentsList = function PaymentsList(_ref2) {
  var _roleAdditionalData$o;

  var match = _ref2.match;

  var _useUser2 = useUser(),
      userInfo = _useUser2.userInfo,
      roleAdditionalData = _useUser2.roleAdditionalData;

  var isPartnerOrPartnerManager = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner_manager;
  var hasOfficeAccess = (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : (_roleAdditionalData$o = roleAdditionalData.offices) === null || _roleAdditionalData$o === void 0 ? void 0 : _roleAdditionalData$o.length) > 0;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u041F\u043B\u0430\u0449\u0430\u043D\u0438\u044F"
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    contentClass: "container-xxl",
    listClass: "container-xxl",
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/all",
    component: AllPaymentsTab,
    label: "\u0412\u0441\u0438\u0447\u043A\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F"
  }), isPartnerOrPartnerManager && ___EmotionJSX(Tab, {
    url: "/pending-report",
    component: PendingReportPayments,
    label: "\u0427\u0430\u043A\u0430\u0449\u0438 \u043E\u0442\u0447\u0435\u0442"
  }), hasOfficeAccess && ___EmotionJSX(Tab, {
    url: "/reported",
    component: ReportedPayments,
    label: "\u041E\u0442\u0447\u0435\u0442\u0435\u043D\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F"
  })));
};

PaymentsList.propTypes = {
  match: PropTypes.object
};
export default PaymentsList;